'use client';

import { HudFrame } from '@/components/marketing/site/hud';
import { MarketingHashScroll } from '@/components/marketing/site/marketing-hash-scroll';
import { SiteHeader } from '@/components/marketing/site/site-header';
import { SiteFooter } from '@/components/marketing/site/site-footer';

export function MarketingShell({ children }: { children: React.ReactNode }) {
  return (
    <>
      <MarketingHashScroll />
      <HudFrame />
      <SiteHeader />
      <main className="relative z-10">{children}</main>
      <SiteFooter />
    </>
  );
}
